import type { User } from '../../types/auth';

export function hasPlatformAccess(user: User | null | undefined): boolean {
  if (!user?.id) return false;
  if (user.role === 'superadmin') return true;
  return user.role === 'admin' && user.tenant_id === 'vanguarda';
}
